import { bindActionCreators } from 'redux';

export const mapState = () => ({});

export const mapDispatch = (dispatch) => ({
	...bindActionCreators({}, dispatch),
});
